import { useMemo } from "react"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { ContentWithAside } from "layouts/kiosk-h"
import { EXTENSION_NAME } from "extensions/iconsiam/constants"
import {
  HomeWithInfosPage,
  HomeWithScreenSaverInfosPage,
  HomeWithScreenSaverPage,
} from "extensions/iconsiam/components/domains/home"
import { useExtension } from "hooks/extension/useExtension"
import { usePageSideBarLayout } from "providers/ui/hooks"

const HOME_VARIANT_COMPONENT_PAGE = {
  "home-with-infos": HomeWithInfosPage,
  "home-with-screensaver": HomeWithScreenSaverPage,
  "home-with-screensaver-infos": HomeWithScreenSaverInfosPage,
}
type HomeVariantComponentPage = keyof typeof HOME_VARIANT_COMPONENT_PAGE

export const HomePage = ({
  Layout = ContentWithAside,
  AppNavigation = DefaultAppNavigation,
}) => {
  const { extensionConfig } = useExtension()

  const HomeComponent = useMemo(() => {
    /* Available variants: "home-with-infos" | "home-with-screensaver" | "home-with-screensaver-infos" */
    //@ts-ignore
    const variant: HomeVariantComponentPage =
      extensionConfig?.[EXTENSION_NAME]?.options?.home?.variant ||
      "home-with-screensaver"
    return HOME_VARIANT_COMPONENT_PAGE[variant]
  }, [extensionConfig])

  usePageSideBarLayout({
    sidebar: {
      open: false,
    },
  })

  return <HomeComponent Layout={Layout} AppNavigation={AppNavigation} />
}
